var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('Keyboard'),_c('Messages'),_c('Drawer'),_c('Header',{attrs:{"versions":"","actions":""}}),_c('SSEAlert'),_c('v-main',{style:(`padding: ${_vm.mainPadding}`)},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }